import { render, staticRenderFns } from "./details_list.vue?vue&type=template&id=b3a93d62&scoped=true&"
import script from "./details_list.vue?vue&type=script&lang=js&"
export * from "./details_list.vue?vue&type=script&lang=js&"
import style0 from "./details_list.vue?vue&type=style&index=0&id=b3a93d62&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3a93d62",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b3a93d62')) {
      api.createRecord('b3a93d62', component.options)
    } else {
      api.reload('b3a93d62', component.options)
    }
    module.hot.accept("./details_list.vue?vue&type=template&id=b3a93d62&scoped=true&", function () {
      api.rerender('b3a93d62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dms/views/channelPool/channelPoolMain/form/details_list.vue"
export default component.exports